import { SharedParams } from './shared-params.const';

// Reports 5006
const ReportService = '/reports';

// Controllers
const CourseReportController = `${ReportService}/course-reports`;
const TraineeReportController = `${ReportService}/trainee-reports`;

export const ReportManagement = {
    CourseReport: {
        CourseReports: CourseReportController,
        CourseReportsExporting: `${CourseReportController}/${SharedParams.Exporting}`,
        CourseReportsExportingPeriodic: `${CourseReportController}/${SharedParams.Exporting}-periodic`,
    },
    TraineeReport: {
        TraineeReports: TraineeReportController,
        TraineeReportsCities: `${TraineeReportController}/cities`,
        TraineeReportsTypes: `${TraineeReportController}/types`,
        TraineeReportsExport: `${TraineeReportController}/${SharedParams.Exporting}`,
    },
};
